import { APP_ROUTE } from '../../../app-routing.constant';
import { UserRole } from '../../authentication';

export type PageRoleMapping = {
  state: string[];
  priority: number;
};

export type PageRoleMappingTable = Record<UserRole, PageRoleMapping>;

// Sorted by priority ascending
export const DEFAULT_PAGE_ROLE_MAPPING: PageRoleMappingTable = {
  [UserRole.admin]: { priority: 1, state: APP_ROUTE.ADMIN.MAIN.route() },
  [UserRole.mediaAdmin]: { priority: 10, state: APP_ROUTE.MEDIA_ADMIN.route() },
  [UserRole.curriculumReviewer]: { priority: 30, state: APP_ROUTE.EDITOR.COURSE.route('') },
  [UserRole.questionCloner]: { priority: 40, state: APP_ROUTE.QUESTION_CLONER.route() },
  [UserRole.reviewer]: { priority: 50, state: APP_ROUTE.REVIEWER.route() },
  [UserRole.firewallAdministrator]: { priority: 60, state: APP_ROUTE.FIREWALL_ADMIN.route() },
  [UserRole.licenseManager]: { priority: 70, state: APP_ROUTE.LICENSE_MANAGER.LICENSES.route() },
  [UserRole.superintendent]: { priority: 90, state: APP_ROUTE.BOARD_ADMIN.BOARD_INSIGHTS.route('d', '0') }, // TODO: TEACH-4056

  // 100
  [UserRole.regionalLeader]: { priority: 100, state: APP_ROUTE.REGIONAL_ADMIN.REGIONAL_INSIGHTS.route('D', '0') }, // TODO: TEACH-4056
  [UserRole.vicePrincipal]: { priority: 110, state: APP_ROUTE.SCHOOL_ADMIN.GET_STARTED.route() },
  [UserRole.principal]: { priority: 120, state: APP_ROUTE.SCHOOL_ADMIN.SCHOOL_BOARD_INSIGHTS.route('d', '0') }, // TODO: TEACH-4056
  [UserRole.teacher]: { priority: 125, state: APP_ROUTE.TEACHERS.CLASS_MANAGEMENT.route() },
  [UserRole.mathLead]: { priority: 130, state: APP_ROUTE.SCHOOL_ADMIN.GET_STARTED.route() },
  [UserRole.mathConsultant]: { priority: 131, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.student]: { priority: 140, state: APP_ROUTE.STUDENT_DEFAULT.route() },
  [UserRole.purchaser]: { priority: 150, state: APP_ROUTE.PURCHASER.CODES.route() },
  [UserRole.premiumSchoolAdministrator]: { priority: 160, state: APP_ROUTE.SCHOOL_ADMIN.MATH_IMPROVEMENT.route() },
  [UserRole.parent]: { priority: 170, state: APP_ROUTE.PARENTS.HOME.route() },
  // 200
  [UserRole.mediaRepresentative]: { priority: 220, state: APP_ROUTE.PARTNERS.DASHBOARD.route() },
  [UserRole.contentViewer]: { priority: 230, state: APP_ROUTE.EDITOR.CONTENT_VIEW.route() },
  [UserRole.contentSearch]: { priority: 240, state: APP_ROUTE.FORBIDDEN.route() },
  [UserRole.translator]: { priority: 250, state: APP_ROUTE.ADMIN.TRANSLATIONS_ABSOLUTE.route() },
  [UserRole.principalAdministrator]: { priority: 260, state: APP_ROUTE.PRINCIPAL_ADMIN.CREATE_ACCOUNT.route() },
  [UserRole.csAdministrator]: { priority: 270, state: APP_ROUTE.CS_ADMIN.DASHBOARD.DISTRICT.route() },
  [UserRole.slsDirector]: { priority: 280, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.mcChiefSuperintendent]: { priority: 281, state: APP_ROUTE.MATH_LEADERS.HOME.route() },
  [UserRole.slsLead]: { priority: 290, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.mcDirector]: { priority: 291, state: APP_ROUTE.MATH_LEADERS.HOME.route() },

  // 300
  [UserRole.slsMathCoach]: { priority: 300, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.mcMathCoach]: { priority: 301, state: APP_ROUTE.MATH_LEADERS.HOME.route() },
  [UserRole.mcMathConsultant]: { priority: 311, state: APP_ROUTE.MATH_LEADERS.HOME.route() },
  [UserRole.slsMathConsultant]: { priority: 320, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.slsMathLead]: { priority: 320, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.mcMathLead]: { priority: 321, state: APP_ROUTE.MATH_LEADERS.HOME.route() },
  [UserRole.slsOther]: { priority: 330, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.mcOther]: { priority: 331, state: APP_ROUTE.MATH_LEADERS.HOME.route() },
  [UserRole.slsPrincipal]: { priority: 340, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.mcPrincipal]: { priority: 341, state: APP_ROUTE.MATH_LEADERS.HOME.route() },
  [UserRole.slsSuperintendent]: { priority: 350, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.mcSuperIntendent]: { priority: 351, state: APP_ROUTE.MATH_LEADERS.HOME.route() },
  [UserRole.slsChiefSuperIntendent]: { priority: 355, state: APP_ROUTE.LEADERSHIP_SERIES.HOME.route() },
  [UserRole.demoSiteAdmin]: { priority: 360, state: APP_ROUTE.DEMO_DISTRICT.route() },

  // All these roles seem to be deprecated, hopefully these routes are never hit
  [UserRole.coach]: { priority: 1000, state: APP_ROUTE.TEACHERS.CLASS_MANAGEMENT.route() },
  [UserRole.viewOnlyParent]: { priority: 2000, state: APP_ROUTE.PARENTS.HOME.route() },
  [UserRole.homeAdministrator]: { priority: 3000, state: APP_ROUTE.PARENTS.HOME.route() },
  [UserRole.salesRepresentative]: { priority: 4000, state: APP_ROUTE.TEACHERS.CLASS_MANAGEMENT.route() }
};
